import { addToast } from 'src/toasts'

function initGoogleMap(locations) {
  const mapElement = document.getElementById("googleMap");
  if (!mapElement) {
    return; // Prevent errors if the map element does not exist
  }

  let geocoder = new google.maps.Geocoder()
  googleMap = new google.maps.Map(document.getElementById("googleMap"), {
    mapId: "GOOGLE_MAP",
    zoom: 12/*,
    center: {
      lat: coords.getAttribute("data-latitude"),
      lng: coords.getAttribute("data-longitude")
    }*/
  });

  let error = false

  for (let i = 0; i < Math.min(locations.length, 100); i++) {
    if (!error) {
      const loc = locations[i]

      geocoder.geocode({ address: loc.address }, (results, status) => {
        if (status === "OK") {
          const bgColor = (loc.color || '#EA4335')
          const borderColor = darken(bgColor, 0.22);
          const glyphColor  = glyphColorFor(bgColor);

          const pin = new google.maps.marker.PinElement({
            background: bgColor,
            borderColor: borderColor,
            glyphColor: borderColor
          });

          const marker = new google.maps.marker.AdvancedMarkerElement({
            map: googleMap,
            position: results[0].geometry.location,
            title: loc.title,
            content: pin.element
          });
          googleMap.setCenter(results[0].geometry.location);
        } else {
          addToast(I18n.t("errors.fetch_address"), 'error')
          error = true
        }
      });
    } else {
      break;
    }
  }

  $("#mainModal .loader").addClass('d-none')
  $("#mainModal #googleMap").removeClass('d-none')
}

function darken(hex, amount = 0.2) {
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  r = Math.round(r * (1 - amount));
  g = Math.round(g * (1 - amount));
  b = Math.round(b * (1 - amount));

  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}

function glyphColorFor(background) {
  const num = parseInt(background.slice(1), 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;

  // Perceived luminance
  const luminance = 0.299*r + 0.587*g + 0.114*b;

  return luminance > 140 ? "#000000" : "#FFFFFF";
}

export function showGoogleMap(mainModal, title, locations) {
  let titleCode = ''
  if (title.length) {
    titleCode = '<div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + title + '</h4></div>'
  }

  $("#mainModal").html('<div class="modal-dialog"><div class="modal-content">' + titleCode + '<div class="modal-body text-center"><div id="googleMap" class="d-none"></div><div class="loader">Loading...</div></div><div class="modal-footer"><button id="modal-cancel" type="button" class="btn btn-secondary"><i class="bi bi-close"></i> ' + I18n.t("buttons.close") + '</button></div></div></div>')
  mainModal.show()

  setTimeout(() => {
    initGoogleMap(locations); // Initialize map when modal is fully shown
  }, 300); // Delay slightly to ensure rendering
}

$.getScript('https://maps.googleapis.com/maps/api/js?key=' + process.env.GOOGLE_MAPS_API_KEY + '&loading=async&libraries=places,marker')
